<template>
  <div class="ec-resource">
    <ResourceLabel
      :key="getLabelKey"
      :name="resource"
      :selected-resource="selectedResource"
      :options="optionsList"
      @selected-resource="updateResourceForAppointments"
    />
    <DayComponent :date="date" :resource="resource" :appts="resourceAppt" />
  </div>
</template>

<script setup>
import DayComponent from "./DayComponent.vue";
import ResourceLabel from "./ResourceLabel.vue";
import { useAppointmentStore } from "../../stores/appointmentsStore";
import { computed } from "vue";
import { useEventStore } from "../../stores/EventStore";

const props = defineProps({
  resource: {
    type: String,
    default: "Overflow",
  },
  selectedResource: {
    type: Object,
    default: () => {},
  },
  date: {
    type: Object,
    default: new Date(),
  },
  resourceAppt: {
    type: Object,
    default: () => ({}),
  },
});
const apptStore = useAppointmentStore();
const eventStore = useEventStore();

const optionsList = computed(() => {
  return apptStore.getStylists.map((el) => ({ id: el.id, name: el.name }));
});
const getLabelKey = computed(() => {
  return props.date.getTime();
});

const updateResourceForAppointments = function (selectedResource) {
  if (!props.resourceAppt || Object.keys(props.resourceAppt).length === 0) {
    return;
  }
  // resourceAppt is an object with datetime keys, each containing an array of appointments
  Object.values(props.resourceAppt).forEach((apptArray) => {
    apptArray.forEach((appt) => {
      appt.stylist = selectedResource.id;
      eventStore.updateEvent(appt);
    });
  });
};
</script>

<style>
.ec-resource {
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
}

#overFlowBox {
  background: #fff;
  border: 1px solid #e7ecf5;
  border-radius: 3px;
  display: relative;
  font-size: 0.8em;
  font-weight: 400;
  padding: 6px;
  color: gray;
  width: 158px;
}
</style>
